import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints'

const StyledPricing = styled.div`
  overflow-x: hidden;

  .hero {
    width: calc(100vw - 80px);
    height: 350px;
    padding: 80px 40px;
    padding-bottom: 1000px;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;

    @media (max-width: ${breakpoints.large}) {
      padding-bottom: 1500px;
    }
    @media (max-width: ${breakpoints.small}) {
      padding-bottom: 2750px;
    }

    .background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.1;
      z-index: 1;
      overflow: hidden;
    }

    .content {
      position: relative;
      z-index: 2;
      text-align: center;
      max-width: 900px;
        pointer-events: none;
      h1 {
        font-size: 54px;
        pointer-events: none;
        line-height: 1.2;
        margin-bottom: 24px;
        color: var(--black);

        @media (max-width: ${breakpoints.medium}) {
          font-size: 48px;
        }

        @media (max-width: ${breakpoints.small}) {
          font-size: 32px;
          margin-bottom: 16px;
        }
      }

      p {
        font-size: 16px;
        color: #595959;
        pointer-events: none;
        line-height: 1.6;
        margin-bottom: 48px;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;

        @media (max-width: ${breakpoints.medium}) {
          font-size: 16px;
          margin-bottom: 32px;
        }

        @media (max-width: ${breakpoints.small}) {
          font-size: 14px;
          margin-bottom: 24px;
          max-width: 100%;
        }
      }

    }
  }

  .billing-toggle {
      margin-top: 350px;
      background-color: rgba(var(--whiter), 0.3);
      padding-top: 50px;
      display: flex;
      gap: 12px;
      z-index: 2;
      position: relative;
      justify-content: center;
      align-items: center;

      @media (max-width: ${breakpoints.small}) {
        flex-direction: column;
        width: 80%;
        padding-left: 10%;
        padding-right: 10%;
        gap: 8px;
      }

      button {
        position: relative;
        padding: 12px 24px;
        border: 1px solid rgba(var(--greyr), 0.3);
        border-radius: 6px;
        background: transparent;
        color: var(--grey);
        cursor: pointer;
        font-size: 14px;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        gap: 8px;

        &:hover {
          border-color: var(--black);
          color: var(--black);
        }

        &.active {
          background-color: var(--black);
          color: var(--white);
          border-color: var(--black);
        }

        @media (max-width: ${breakpoints.small}) {
          width: 100%;
          justify-content: center;
          padding: 10px 20px;
          font-size: 13px;
        }

        .badge {
          font-size: 10px;
          padding: 2px 8px;
          background-color: var(--green);
          color: var(--white);
          border-radius: 4px;
          font-weight: 600;
        }
      }

    }

  .comparison {
    z-index: 2;
    position: relative;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);
    background-color: white;
  }



  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

`;

export default StyledPricing;
